import { render, staticRenderFns } from "./ShareOn.vue?vue&type=template&id=f6430d1e"
import script from "./ShareOn.vue?vue&type=script&lang=js"
export * from "./ShareOn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports